var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base light"},[_c('CursorCustom',{attrs:{"theme":_vm.theme}}),_c('BaseView',{attrs:{"theme":_vm.theme,"appear":_vm.appear,"orientation":_vm.orientation}},[_c('PageFloors')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }